<template>
  <div>
    <p class="text-gray-400 my-1">Упавление отображением демо данных.</p>
    <p class="text-gray-400 my-1 mb-4">При включении переключиться только отображение, сервис продолжит собирать данные.</p>
    <div v-if="!loading">
      <div v-if="!error">
        <p class="mb-4" :style="{color: demoData?.enabled ? 'green' : 'gray'}">
          Состояние: {{ demoData?.enabled ? "Включены" : "Отключены" }}
        </p>
        <button @click.prevent="switchDemoData" class="px-4 py-2 mt-2 text-white rounded transition-colors cursor-pointer" :class="!demoData?.enabled ? 'bg-gray-500 hover:bg-gray-600' : 'bg-green-500 hover:bg-green-600'">
          {{ demoData?.enabled ? "Отключить" : "Включить"}}
        </button>
      </div>
      <p class="text-red-600" v-else>
        Ошибка
      </p>
    </div>
    <LoaderIcon v-else/>
  </div>
</template>

<script>
import LoaderIcon from "@/components/LoaderIcon.vue";

export default {
  name: 'DemoDataBlock',
  components: {LoaderIcon},
  data() {
    return {
      demoData: null,
      error: null,
      loading: true,
      confirmModal: {
        title: "Создание нового ключа",
        message: "Создать новый ключ доступа?",
        show: false,
      }
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData: function () {
      console.log("load demo info")
      let c = this;
      c.demoData = null;
      c.loading = true;
      c.error = false;
      this.axios.get('/api/settings/account-demo').then(function(response) {
        console.log(response.data);
        c.demoData = response.data.data;
        c.loading = false;
      }).catch(function(err) {
        console.log(err.status);
        c.loading = false;
        c.error = true;
      });
    },
    switchDemoData: function () {
      console.log("switchDemoData")
      let c = this;
      c.demoData = null;
      if (c.loading) {
        return;
      }
      c.loading = true;
      this.axios.post('/api/settings/account-demo').then(function(response) {
        c.loading = false;
        console.log(response.data);
        c.demoData = response.data.data;
      }).catch(function(err) {
        c.loading = false;
        console.log(err.status);
      });
    }
  }
}
</script>

<style scoped>

</style>